<template>
  <div id="app">
    <div class="body_bg">
      <div class="container pd15 whitebg">
        <el-row :gutter="25">
            <div class="grid-content bg-purple-light">
              <div class="side_con">
                
                <listContent></listContent>
              </div>
            </div>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
  import listContent from '../components/listContent'
  export default {
    data() {
      return {
        title:"",
        ColumnId:0
      }
    },
    components: {
      listContent
    },
  
  }
</script>

<style scoped>

</style>
